"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _camera = _interopRequireDefault(require("@atlaskit/icon/core/camera"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorPhotoIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 8.51c0-.282.22-.51.498-.51h13.004c.275 0 .498.228.498.51v8.98c0 .282-.22.51-.498.51H5.498A.504.504 0 0 1 5 17.49zm5-1.01c0-.276.215-.5.49-.5h3.02a.5.5 0 0 1 .49.5V8h-4zm2 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-1.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4"/></svg>`
}, props, {
  newIcon: _camera.default
}));
EditorPhotoIcon.displayName = 'EditorPhotoIcon';
var _default = exports.default = EditorPhotoIcon;